@let hasEnoughPoints = dataService.totalPoints() >= data.priceToUnlock;
<div
  role="dialog"
  aria-modal="true"
  class="modal-wrapper"
  data-cy="select_reward_dialog"
  [style.background]="config.background"
  [attr.aria-label]="
    !data.isActive ? config.ariaLabel : config.ariaLabelSelected
  "
>
  <div class="dialog-header">
    @let selectedLabel = config.header.title.label.selected;
    @let defaultLabel =
      hasEnoughPoints
        ? config.header.title.label.default.hasEnoughPoints
        : config.header.title.label.default.lacksPoints;
    <h3
      class="title"
      [style]="{
        color: config.header.title.color,
        fontFamily: config.header.title.fontFamily,
      }"
    >
      {{ !data.isActive ? defaultLabel : selectedLabel }}
    </h3>
    <b2c-icon
      class="close-button"
      (click)="closeModal()"
      [icon]="config.header.closeButton.icon"
      [buttonTitle]="config.header.closeButton.alternativeText"
    />
  </div>

  <div class="modal-content" #pdfContent>
    <img class="header-image" [alt]="data.label" [src]="data.bannerLink" />

    <h6
      class="sublabel"
      [style]="{
        color: config.subTitle.color,
        fontFamily: config.subTitle.fontFamily,
      }"
    >
      {{ data.sublabel }}
    </h6>

    @if (!data.isActive) {
      <div
        class="expiration-date"
        [style]="{
          color: config.inactiveState.expirationDate.color,
          fontFamily: config.inactiveState.expirationDate.fontFamily,
        }"
        [innerHTML]="
          config.inactiveState.expirationDate.template
            | replaceVars
              : (data.expirationDate! | date: 'dd MMMM yyyy' : '' : locale)!
            | safe
        "
      ></div>
      <p
        class="modal-description"
        [style]="{
          color: config.inactiveState.description.color,
          fontFamily: config.inactiveState.description.fontFamily,
        }"
      >
        {{ config.inactiveState.description.label }}
      </p>

      @if (dataService.totalPoints() < data.priceToUnlock) {
        @let pointsLeft = data.priceToUnlock - dataService.totalPoints();
        <div
          class="warning"
          [style]="{
            color: config.inactiveState.warningMessage.color,
            fontFamily: config.inactiveState.warningMessage.fontFamily,
            backgroundColor:
              config.inactiveState.warningMessage.backgroundColor,
          }"
          [innerHTML]="
            config.inactiveState.warningMessage.template
              | replaceVars: pointsLeft
              | safe
          "
        ></div>
      }
    } @else {
      <!-- Code implementation -->
      <div class="code-details">
        @let codeDetails = data.codeDetails;
        @if (codeDetails) {
          @switch (codeDetails.type) {
            @case (RewardCode.QRCODE) {
              <canvas #qrcode></canvas>
            }
            @case (RewardCode.BARCODE) {
              <svg #barcode></svg>
            }
            @case (RewardCode.IMAGE_LINK) {
              <img
                class="responsive-width"
                [src]="codeDetails.value"
                [alt]="config.altRewardImageType"
              />
            }
            @case (RewardCode.CLICKABLE_LINK) {
              <a
                target="_blank"
                rel="noopener noreferrer"
                [href]="codeDetails.value"
                >{{ codeDetails?.value }}</a
              >
            }
            @default {
              <p class="code">{{ codeDetails.value }}</p>
            }
          }
        }
      </div>

      <div
        class="expiration-date"
        [style]="{
          color: config.activeState.expirationDate.color,
          fontFamily: config.activeState.expirationDate.fontFamily,
        }"
        [innerHTML]="
          config.activeState.expirationDate.template
            | replaceVars: (data.expirationDate! | date: 'dd' : '' : locale)!
            | replaceVars: (data.expirationDate! | date: 'MMMM' : '' : locale)!
            | replaceVars: (data.expirationDate! | date: 'yyyy' : '' : locale)!
            | safe
        "
      ></div>
    }

    <p
      aria-hidden="true"
      data-terms-print="true"
      class="terms-and-conditions-export"
      [innerHTML]="data.termsAndConditions! | safe"
    ></p>
  </div>

  <div class="modal-footer">
    @if (showError()) {
      <p
        class="error"
        [style]="{
          color: config.errorMessage.color,
          fontFamily: config.errorMessage.fontFamily,
        }"
        [innerHTML]="config.errorMessage.label | safe"
      ></p>
    }
    @if (!data.isActive) {
      @let selectionButtonConfig = config.selectionButton;
      @let specificConfig =
        hasEnoughPoints
          ? selectionButtonConfig.hasEnoughPoints
          : selectionButtonConfig.lacksPoints;
      <button
        type="button"
        [title]="
          selectionButtonConfig.ariaLabel
            | replaceVars: data.priceToUnlock.toString()
        "
        [attr.aria-label]="
          selectionButtonConfig.ariaLabel
            | replaceVars: data.priceToUnlock.toString()
        "
        [innerHTML]="
          selectionButtonConfig.template
            | replaceVars: data.priceToUnlock.toString()
            | safe
        "
        class="btn btn-selection"
        (click)="handleSelection()"
        data-cy="select_btn_confirmation"
        [style.color]="specificConfig.color"
        [style.border]="specificConfig.border"
        [style.fontFamily]="selectionButtonConfig.fontFamily"
        [style.backgroundColor]="specificConfig.backgroundColor"
      ></button>
    } @else {
      <b2c-button
        type="button"
        class="btn-export"
        data-cy="export_btn"
        (click)="handleExport()"
        [title]="config.exportButton.label"
        [styles]="{
          borderRadius: '50px',
          color: config.exportButton.color,
          border: config.exportButton.border,
          fontFamily: config.exportButton.fontFamily,
          backgroundColor: config.exportButton.backgroundColor,
        }"
      >
        <span class="label">{{ config.exportButton.label }}</span>
      </b2c-button>
    }

    <b2c-button
      type="button"
      class="btn-tc"
      data-cy="tc_btn"
      (click)="showTermsAndConditions()"
      [title]="config.termsAndConditionsButton.label"
      [styles]="{
        border: 'none',
        fontSize: '14px',
        borderRadius: '0',
        backgroundColor: 'transparent',
        color: config.termsAndConditionsButton.color,
        fontFamily: config.termsAndConditionsButton.fontFamily,
      }"
    >
      <span class="label">{{ config.termsAndConditionsButton.label }}</span>
    </b2c-button>
  </div>
</div>
